exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sketch[data-v-6542a5cf]{float:right;background-color:#fff;margin:auto 5px;width:70%;height:60px;overflow-y:scroll;border-radius:5px;border:4px solid hsla(0,0%,100%,.15);box-shadow:1px 1px 4px rgba(0,0,0,.3);font-family:entypo,sans-serif;font-size:12px}article[data-v-6542a5cf]:before{content:\"\";background:inherit;-webkit-filter:blur(5px);filter:blur(5px)}ul[data-v-6542a5cf]{list-style-type:none}li[data-v-6542a5cf]{margin-bottom:.5rem;color:#000}li[data-v-6542a5cf]:before{color:#597572;margin-right:2px}a[data-v-6542a5cf]{background:rgba(0,0,0,.1);color:#ff0;text-decoration:none;text-transform:uppercase;border-radius:5px;letter-spacing:1px;display:inline-block;padding:0 2px;padding-top:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6542a5cf&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/introduction.vue
// module id = 64
// module chunks = 0